import { motion } from "framer-motion";

// internal imports
import { Wrapper, Section } from "./social-bar.styles";
import { GitHub, LinkedIn, Facebook, LanguageSelector } from "../index";

const leftIcons = [<GitHub />, <LinkedIn />];
const rightIcons = [<Facebook />, <LanguageSelector />];

const SocialBar = () => {
  return (
    <Wrapper>
      <Section>
        {leftIcons.map((icon, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: "10vw" }}
            animate={{
              opacity: 1,
              x: 0,
              transition: { type: "spring", stiffness: 150, delay: i * 0.1 },
            }}
          >
            {icon}
          </motion.div>
        ))}
      </Section>
      <Section>
        {rightIcons.map((icon, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: "-10vw" }}
            animate={{
              opacity: 1,
              x: 0,
              transition: { type: "spring", stiffness: 150, delay: i * 0.1 },
            }}
          >
            {icon}
          </motion.div>
        ))}
      </Section>
    </Wrapper>
  );
};
export default SocialBar;
